<template>
  <div v-if="refData" class="referral-panel">
    <img class="raf-logo" src="~@/assets/raf-logo-sm.png" alt="RAF logo">
    <div class="icon">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M13.7743 5.78905L14.0863 3.70256C14.1369 3.37056 14.3024 3.06422 14.5565 2.83223C14.8105 2.60024 15.1386 2.45592 15.4886 2.42222C15.8878 2.38555 16.2865 2.49627 16.6027 2.7316C16.9188 2.96692 17.1284 3.30892 17.1881 3.68718C17.2479 4.06544 17.1533 4.45116 16.9239 4.76491C16.6945 5.07865 16.3476 5.29654 15.9549 5.37371L13.7743 5.78905ZM10.7143 8.46583V11.7362H3.42857C3.20124 11.7362 2.98323 11.65 2.82248 11.4967C2.66173 11.3434 2.57143 11.1354 2.57143 10.9186V9.28342C2.57143 9.06658 2.66173 8.85862 2.82248 8.70529C2.98323 8.55197 3.20124 8.46583 3.42857 8.46583H10.7143ZM12 2.02978C11.7305 1.57329 11.3686 1.1725 10.9351 0.850756C10.5017 0.529013 10.0055 0.292746 9.47541 0.155715C8.94531 0.0186844 8.39194 -0.0163703 7.8475 0.0525924C7.30306 0.121555 6.77846 0.293157 6.30423 0.557403C5.83 0.821649 5.41564 1.17326 5.08526 1.59175C4.75489 2.01024 4.51512 2.48725 4.37991 2.995C4.2447 3.50275 4.21676 4.03108 4.29771 4.54923C4.37866 5.06738 4.56689 5.56498 4.85143 6.01306H3.42857C2.51926 6.01306 1.64719 6.35762 1.00421 6.97093C0.361224 7.58424 0 8.41607 0 9.28342V10.9186C1.52888e-05 11.4926 0.158444 12.0566 0.459363 12.5537C0.760282 13.0509 1.19309 13.4637 1.71429 13.7507V19.0945C1.71429 20.3955 2.25612 21.6432 3.22059 22.5632C4.18507 23.4832 5.49317 24 6.85714 24H17.1429C18.5068 24 19.8149 23.4832 20.7794 22.5632C21.7439 21.6432 22.2857 20.3955 22.2857 19.0945V13.7507C22.8069 13.4637 23.2397 13.0509 23.5406 12.5537C23.8416 12.0566 24 11.4926 24 10.9186V9.28342C24 8.41607 23.6388 7.58424 22.9958 6.97093C22.3528 6.35762 21.4807 6.01306 20.5714 6.01306H19.1486C19.4367 5.56487 19.628 5.06633 19.7115 4.54666C19.7949 4.02699 19.7687 3.49666 19.6344 2.98678C19.5001 2.4769 19.2604 1.99772 18.9294 1.57737C18.5984 1.15701 18.1827 0.803922 17.7068 0.538821C17.2308 0.27372 16.7042 0.101939 16.1577 0.0335523C15.6112 -0.034834 15.0559 0.00155126 14.5244 0.140574C13.9928 0.279597 13.4957 0.518459 13.0623 0.84315C12.6288 1.16784 12.2676 1.57183 12 2.03141M13.2857 8.87626V11.7362H20.5714C20.7988 11.7362 21.0168 11.65 21.1775 11.4967C21.3383 11.3434 21.4286 11.1354 21.4286 10.9186V9.28342C21.4286 9.06658 21.3383 8.85862 21.1775 8.70529C21.0168 8.55197 20.7988 8.46583 20.5714 8.46583H13.2857V8.87626ZM10.7143 14.1889H4.28571V19.0945C4.28571 19.745 4.55663 20.3689 5.03887 20.8288C5.5211 21.2888 6.17516 21.5472 6.85714 21.5472H10.7143V14.1889ZM13.2857 21.5472V14.1889H19.7143V19.0945C19.7143 19.745 19.4434 20.3689 18.9611 20.8288C18.4789 21.2888 17.8248 21.5472 17.1429 21.5472H13.2857ZM9.91371 3.70256L10.2257 5.78905L8.04514 5.37371C7.65235 5.29654 7.30553 5.07865 7.0761 4.76491C6.84667 4.45116 6.7521 4.06544 6.81186 3.68718C6.87162 3.30892 7.08116 2.96692 7.39733 2.7316C7.7135 2.49627 8.11224 2.38555 8.51143 2.42222C8.86137 2.45592 9.18946 2.60024 9.44354 2.83223C9.69763 3.06422 9.86312 3.37056 9.91371 3.70256Z"
          fill="currentColor" />
      </svg>
    </div>
    <div class="title">{{ title }}</div>
    <div class="text">
      <div v-html="text"></div>
    </div>
    <f7-link :href="linkUrl" class="link accent">{{ noReferrals ? 'Refer now' : 'View referrals' }}</f7-link>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { PAGES } from '../../shared/routes.constants'
import { ReferralProgramType } from '../../shared/enums/referral.enum'
export default {
  name: 'referral-panel',
  computed: {
    ...mapState({
      refData: (state) => state.recommendFriend.mainInfo,
      customerUser: (state) => state.editUserProfile.customerUser,
      salesPersonFirst: (state) => state.common.salesPersonFullName.split(' ')[0] || ''
    }),
    ...mapGetters({
      sharedLinkData: 'recommendFriend/sharedLinkData'
    }),
    totalWin () {
      return this.refData.rewardTotal + this.refData.awardTotal
    },
    noReferrals () {
      if (!this.refData) {
        return
      }
      return !this.refData.referred
    },
    linkUrl () {
      return this.noReferrals ? this.referralUrl : this.referralHistoryUrl
    },
    title () {
      return `Welcome${!this.noReferrals ? ' back' : ''}${this.customerUser && !this.customerUser.isDemoUser ? `, ${this.customerUser.firstName}` : ''}!`
    },
    text () {
      const { referralProgramId, referred, giveReward, awardTotal, purchased, referralAward, rewardTotal } = this.refData
      let result
      switch (referralProgramId) {

        case ReferralProgramType.NonMonetary:
          if (!referred) {
            result = `Help friends connect with ${this.salesPersonFirst}`
          } else if (purchased) {
            result = `<span class="accent">${referred}</span> friends referred · <span class="accent">${purchased}</span> bought - great job!`
          } else {
            result = `<span class="accent">${referred}</span> friends referred - thank you!`
          }
          break

        case ReferralProgramType.ReferralAward:
          if (!referred) {
            result = `Earn <span class="accent">$${referralAward}</span> for every friend who buys`
          } else if (purchased) {
            result = `<span class="accent">${referred}</span> friends referred · <span class="accent">$${awardTotal}</span> awarded`
          } else {
            result = `<span class="accent">${referred}</span> friends referred - waiting on a purchase`
          }
          break

        case ReferralProgramType.GiveAndGet:
          if (!referred) {
            result = `Give $${giveReward} to friends, earn $${rewardTotal} for you`
          } else if (purchased) {
            result = `<span class="accent">${referred}</span> friends referred · <span class="accent">$${awardTotal}</span> awarded`
          } else {
            result = `<span class="accent">${referred}</span> friends referred - waiting on a purchase`
          }
          break
      }

      return result
    }
  },
  methods: {
    ...mapActions({
      getInfo: 'recommendFriend/getInfo'
    })
  },
  data () {
    return {
      PAGES: PAGES,
      referralHistoryUrl: PAGES.RecommendAFriendHistory,
      referralUrl: PAGES.RecommendAFriend
    }
  }
}
</script>

<style scoped lang="scss">
.referral-panel {
  --accent-color: #033BAA;
  --icon-bg-color: #033BAA1A;
  --icon-size: 58px;

  width: 100%;
  max-width: 360px;
  background-color: #fff;
  border-radius: 16px;
  padding: 16px;
  display: grid;
  grid-template-columns: var(--icon-size) 1fr;
  grid-template-areas: 'logo logo' 'icon title' 'icon text' 'icon cta';
  column-gap: 8px;

  .raf-logo {
    grid-area: logo;
    justify-self: center;
    margin-bottom: 12px;
  }

  .icon {
    grid-area: icon;
    display: grid;
    place-content: center;
    width: var(--icon-size);
    height: var(--icon-size);
    aspect-ratio: 1;
    border-radius: 50%;
    background-color: var(--icon-bg-color);
    color: var(--accent-color);
  }

  .title {
    grid-area: title;
    font-weight: 700;
    font-size: 16px;
    line-height: 1;
  }

  .text {
    grid-area: text;
    font-weight: 700;
    font-size: 12px;
  }

  .link {
    grid-area: cta;
    font-weight: 700;
    font-size: 12px;
    justify-self: start;
    width: auto;
    color: var(--accent-color);
  }
}
</style>
<style>
.accent {
    color: var(--accent-color);
  }
</style>



// WEBPACK FOOTER //
// referral-panel.vue?42cfa624